/**
 *
 * Styles for OfferPromotedLine
 *
 */

import styled from "styled-components";
import { DhlText, DhlLink } from "@dhl-official/react-library";
import { breakpoints } from "root/libs/ui-styleguide/src";

export const PromotedTextWrapper = styled.div`
  display: flex;
  ${(props) => (props.showInViewport === "mobile" ? "display: flex" : "")};
  ${(props) => (props.showInViewport === "desktop" ? "display: none" : "")};

  @media screen and (min-width: ${breakpoints.tablet}) {
    ${(props) => (props.showInViewport === "mobile" ? "display: none" : "")};
    ${(props) => (props.showInViewport === "desktop" ? "display: flex" : "")};
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding-right: var(--gaq-size-space-50px);
    align-items: center;
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    padding-right: 0;
    align-items: inherit;
  }
`;

export const PromotedText = styled(DhlText)`
  min-height: 32px;
  min-height: 11%;
`;

export const PromotedLink = styled(DhlLink)`
  & > dhl-button > .styled:is(button, a) {
    text-decoration: underline !important;
    color: var(--dui-color-black-500) !important;
    & > span {
      font-size: 1.4rem !important;
      font-weight: 700 !important;
    }
  }
`;
